import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./ReaderPage.css";

const markdownContent = `
# Screen Reader Widget SDK

## Overview
The Screen Reader Widget enables text-to-speech functionality within any web application. This SDK walks through the process of **building the widget from scratch**, covering:
- **UI and event handling**
- **Fetching speech from an API**
- **Implementing text selection and highlighting**
- **Audio playback and speaker selection**

---

## Widget Architecture

### UI Components
The widget consists of:
- A floating control panel with a "Read Text" button.
- A collapsible settings panel for speaker selection and highlighting.
- An audio player for text-to-speech playback.

### Workflow
1. User selects text → Widget detects selection.
2. User clicks "Read Text" → The widget sends text to the API.
3. API returns generated speech → Audio is played.
4. Words are highlighted in real-time as they are spoken.

---

## Setting Up the Widget

To add the widget dynamically to any webpage, inject **\`widget.js\`** into the site:

\`\`\`html
<script src="https://yourdomain.com/widget.js"></script>
\`\`\`

Once included, initialize the widget:
\`\`\`js
window.ScreenReaderWidget.init();
\`\`\`
`;

const ReaderPage = () => {
    useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://wsl.nategrieb.com/widget.js"; // ✅ Load from the frontend      
    
        script.async = true;
    
        script.onload = () => {
            const checkElementExists = setInterval(() => {
                const articleElement = document.querySelector("#article-content");
                if (articleElement && window.ScreenReaderWidget && typeof window.ScreenReaderWidget.init === "function") {
                    clearInterval(checkElementExists); // Stop checking once it's found
                    console.log("✅ #article-content found. Initializing widget...");
        
                    window.ScreenReaderWidget.init({ selector: "#article-content" });
        
                    // ✅ Log the text that will be used for reading
                    console.log("📖 Text detected in #article-content:", articleElement.innerText.trim());
                }
            }, 100); // Check every 100ms
        };        
        document.body.appendChild(script);
    
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

  return (
    <div className="knowledge-article">
      {/* ✅ Wrap readable content inside a dedicated div */}
      <div id="article-content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            code({ node, inline, className, children, ...props }) {
              return null; // ✅ Skip code blocks so they are NOT read aloud
            }
          }}
        >
          {markdownContent}
        </ReactMarkdown>
      </div>

      <div id="widget-container" className="widget-section">
        <p>Widget will load here...</p>
      </div>
    </div>
  );
};

export default ReaderPage;